export default "__VITE_ASSET__1f5b7f8c__"